import { render, staticRenderFns } from "./StockableItemImportRequests.vue?vue&type=template&id=3596c94c&"
import script from "./StockableItemImportRequests.vue?vue&type=script&lang=ts&"
export * from "./StockableItemImportRequests.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports